import { Box, Typography } from "@mui/material";
import { statusPanelSx, statusSectionTitleSx } from "../statusStyles";
import type { ClaimTranslator } from "../types";

type PhotosSectionProps = {
  imageUrls?: string[];
  t: ClaimTranslator;
};

export const PhotosSection = ({ imageUrls, t }: PhotosSectionProps) => {
  if (!imageUrls?.length) {
    return null;
  }

  return (
    <Box mb="16px" sx={statusPanelSx()}>
      <Typography sx={{ ...statusSectionTitleSx, mb: "12px" }}>
        {t("status.photos")}
      </Typography>
      <Box display="flex" flexWrap="wrap" gap="10px">
        {imageUrls.map((url, index) => (
          <Box
            key={`${url}-${index}`}
            sx={{
              width: "75px",
              height: "75px",
              overflow: "hidden",
              borderRadius: "8px",
              "& img": {
                width: "100%",
                height: "100%",
                objectFit: "cover",
              },
            }}
          >
            <img src={url} loading="lazy" alt="" />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
